// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  margin: 1em auto;
}
.header h3 {
  margin: 0;
}
@media screen and (max-width: 780px) {
  .header {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  .header .header-buttons {
    margin: 1rem 0;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.group-field {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.field-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV0bC1kaWN0aW9ubmFyeS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGFBQUE7RUFDQSw4QkFBQTtFQUNBLGdCQUFBO0FBQ0o7QUFDSTtFQUNJLFNBQUE7QUFDUjtBQUVJO0VBVEo7SUFVUSx1QkFBQTtJQUNBLDhCQUFBO0VBQ047RUFDTTtJQUNJLGNBQUE7RUFDVjtBQUNGOztBQUdBO0VBQ0ksYUFBQTtFQUNBLHlCQUFBO0VBQ0EsbUJBQUE7QUFBSjs7QUFHQTtFQUNJLGFBQUE7RUFDQSxlQUFBO0VBQ0EsU0FBQTtBQUFKOztBQUdBO0VBQ0ksYUFBQTtFQUNBLHNCQUFBO0VBQ0EsU0FBQTtBQUFKIiwiZmlsZSI6ImV0bC1kaWN0aW9ubmFyeS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5oZWFkZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIG1hcmdpbjogMWVtIGF1dG87XG5cbiAgICBoMyB7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICB9XG5cbiAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA3ODBweCkge1xuICAgICAgICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbi1yZXZlcnNlO1xuXG4gICAgICAgIC5oZWFkZXItYnV0dG9ucyB7XG4gICAgICAgICAgICBtYXJnaW46IDFyZW0gMDtcbiAgICAgICAgfVxuICAgIH1cbn1cblxuLmJ1dHRvbnMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xufVxuXG4uZ3JvdXAtZmllbGQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIGdhcDogMXJlbTtcbn1cblxuLmZpZWxkLWxpc3Qge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBnYXA6IDFyZW07XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl-dictionnary/etl-dictionnary.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AACJ;AACI;EACI,SAAA;AACR;AAEI;EATJ;IAUQ,uBAAA;IACA,8BAAA;EACN;EACM;IACI,cAAA;EACV;AACF;;AAGA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AACA,o1CAAo1C","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    margin: 1em auto;\n\n    h3 {\n        margin: 0;\n    }\n\n    @media screen and (max-width: 780px) {\n        align-items: flex-start;\n        flex-direction: column-reverse;\n\n        .header-buttons {\n            margin: 1rem 0;\n        }\n    }\n}\n\n.buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 1rem;\n}\n\n.group-field {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.field-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
